import 'Assets/styles/default/pages/viewRedemption/ViewRedemptionStyles.less';
import React from 'react';
import { Typography, VertContainer, VertIcon } from '@vertem-core/vertice-ds';
import { format } from 'date-fns';
import PropTypes from 'prop-types';
import { Row } from 'antd';

export const SpotHistory = ({ histories, isManager }) => {
  const getManager = (value) => {
    switch (value) {
      case 1:
        return 'Operacional:';
      case 2:
        return 'PMO:';
      case 3:
        return 'Gestor:';
      case 4:
        return 'Participante:';
      default:
        return '---';
    }
  };

  const validateStatus = (status, isManager) => {
    if (isManager) return true;
    switch (status) {
      case 3:
        return true;
      case 4:
        return true;
      case 5:
        return true;
      case 6:
        return true;
      case 7:
        return true;
      default:
        return false;
    }
  };

  return (
    <>
      <VertContainer className="container-subtitle-view-redemption">
        <VertIcon
          size="large"
          className="spacing-icon"
          isVertice
          iconName="Chronometer"
        />
        <Typography.Text className="subtitle-view-redemption">
          Histórico
        </Typography.Text>
      </VertContainer>
      <VertContainer className="container-history">
        {histories.length === 0 ? (
          <div className="history-timeline">
            Ainda não há histórico a ser exibido.
          </div>
        ) : (
          histories.map((item) => {
            let historyClass = '';
            let historyText = '';
            if (item.redemptionStatusId === 5) {
              historyClass = 'cancel';
              historyText = 'Cancelado';
            } else if (item.redemptionStatusId === 7) {
              historyClass = 'pending';
              historyText = 'Reaberto';
            } else if (item.redemptionStatusId === 8) {
              historyClass = 'pending';
              historyText = 'Nova cotação';
            } else if (item.redemptionStatusId === 9) {
              historyClass = 'pending';
              historyText = 'Solicitação Editada';
            } else {
              historyClass = 'approved';
              historyText = 'Aprovado';
            }
            return (
              validateStatus(item.redemptionStatusId, isManager) && (
                <VertContainer
                  className={`history-timeline history-timeline-${historyClass} line-${historyClass}`}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'start',
                      alignItems: 'center',
                    }}
                  >
                    <Row className="container-history-status-date">
                      <Typography.Text
                        className={`history-status status-${historyClass}`}
                      >
                        {historyText}
                      </Typography.Text>
                      <div className="container-history-date">
                        <Typography.Text className="text-history-date">
                          {format(new Date(item.date), 'dd/MM/yyyy')}
                        </Typography.Text>
                      </div>
                    </Row>

                    <div className="container-redemption-status">
                      {isManager && (
                        <Typography.Text className="history-type">
                          {getManager(item.redemptionStatusId)}
                        </Typography.Text>
                      )}
                      {isManager && (
                        <Typography.Text className="history-type ellipsis">
                          {item.approverName}
                        </Typography.Text>
                      )}
                    </div>
                  </div>
                  <Typography.Text className="text-history-description">
                    {item.description}
                  </Typography.Text>
                </VertContainer>
              )
            );
          })
        )}
      </VertContainer>
    </>
  );
};

SpotHistory.propTypes = {
  histories: PropTypes.array.isRequired,
  isManager: PropTypes.bool.isRequired,
};
